import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/Card';
import { lotteryService } from '../../services/lotteryService';
import { formatMoney } from '../../utils/formatMoney';
import { PrizeDigits } from './PrizeDigits';

function PrizeBlock({ title, amount, digits, periodLabel }) {
  return (
    <Card className="flex-1">
      <CardContent className="text-center">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className="mt-1 text-lg font-bold text-brand-gold">
          {formatMoney(amount)}
        </p>
        <div className="mt-3">
          <p className="mb-2 text-xs font-medium text-gray-500">
            {periodLabel
              ? `ผลงวดล่าสุด (${periodLabel})`
              : 'ผลงวดล่าสุด'}
          </p>
          <PrizeDigits digits={digits} />
        </div>
      </CardContent>
    </Card>
  );
}

export function SecondaryPrize() {
  const [prizes, setPrizes] = useState(null);

  useEffect(() => {
    const load = () => {
      lotteryService.getPrizes().then(setPrizes).catch(() => {});
    };
    load();
    const timer = setInterval(load, 5000);
    return () => clearInterval(timer);
  }, []);

  if (!prizes) return null;

  const periodLabel = prizes.lastDraw?.period;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <PrizeBlock
        title="รางวัลที่ 2 (3 ตัว)"
        amount={prizes.secondPrize}
        digits={prizes.secondDigits}
        periodLabel={periodLabel}
      />
      <PrizeBlock
        title="รางวัลที่ 3 (2 ตัว)"
        amount={prizes.thirdPrize}
        digits={prizes.thirdDigits}
        periodLabel={periodLabel}
      />
    </div>
  );
}
